import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-successful-created',
  templateUrl: './successful-created.component.html',
  styleUrls: ['./successful-created.component.scss'],
})
export class SuccessfulCreatedComponent implements OnInit {
  constructor(
    private route: Router,
    private modalCtrl: ModalController,
    public platform: Platform
  ) {}

  ngOnInit() {}

  dismissModal(link: string = '') {
    this.modalCtrl.dismiss();
    this.route.navigate([link]);
  }
}
